(function() {
    angular
        .module("app")
        .controller("WzQwsConfirmUnsetOutputInputDeviceController", WzQwsConfirmUnsetOutputInputDeviceController)

    WzQwsConfirmUnsetOutputInputDeviceController.$inject = [
        "$scope",
        "$uibModalInstance",
        "confirm",
        "deviceType",
        "name"
    ]

    function WzQwsConfirmUnsetOutputInputDeviceController(
        $scope,
        $uibModalInstance,
        confirm,
        deviceType,
        name
    ){
        "use strict"

        $scope.deviceType = deviceType
        $scope.name       = name

        $scope.cancel = () => {
            $uibModalInstance.dismiss("cancel")
        }

        $scope.confirm = () => {
            $uibModalInstance.close(confirm())
        }
    }
})()
